module.exports = __webpack_public_path__ + "static/media/profilelogo7.66a1ec9d.png";